import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/businessstorepro/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/businessstorepro/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/businessstorepro/app/node_modules/next/font/google/target.css?{\"path\":\"src/config/fonts.ts\",\"import\":\"Cairo\",\"arguments\":[{\"subsets\":[\"arabic\"],\"variable\":\"--font-cairo\",\"display\":\"swap\"}],\"variableName\":\"fontCairo\"}");
